import { publicClient, privateClient } from "../../configs/axiosConfig";

const userEndpoints = {
  signin: "v2/operator/login",
  updateProfile: "v2/operator/operatorUpdate",
  passwordUpdate: "v2/operator/password/update",

  // OTP endpoints
  verifyOtp: "v2/operator/verify-otp",
  resendOtp: "v2/operator/resend-otp",

  getInfo: "v1/user/info",
  getAllUsers: "v1/user/allUsers",
};

const userApi = {
  signin: async ({ username, password, masterOtp }) => {
    try {
      const response = await publicClient.post(userEndpoints.signin, {
        username,
        password,
        ...(masterOtp ? { masterOtp } : {}), // ✅ only attach if provided
      });

      return { response };
    } catch (err) {
      console.log("err Dr. Man Ha Sign in API", err);
      // don't swallow error
      throw err; // 👈 let frontend catch it    }
    }
  },
  signup: async ({
    username,
    password,
    confirmPassword,
    displayName,
    photo,
  }) => {
    try {
      const response = await publicClient.post(userEndpoints.signup, {
        username,
        password,
        confirmPassword,
        displayName,
        photo,
      });

      return { response };
    } catch (err) {
      return { err };
    }
  },

  // ✅ Verify login OTP (signin flow)
  verifyOtp: async ({ otp, email }) => {
    try {
      const response = await publicClient.post(userEndpoints.verifyOtp, {
        otp,
        email,
      });
      return response.data; // { user, token, message }
    } catch (err) {
      throw err;
    }
  },

  // ✅ Resend OTP
  resendOtp: async (email) => {
    try {
      const response = await publicClient.post(userEndpoints.resendOtp, {
        email,
      });
      return response.data; // { message }
    } catch (err) {
      throw err;
    }
  },
  getInfo: async () => {
    try {
      const response = await privateClient.get(userEndpoints.getInfo);

      return { response };
    } catch (err) {
      return { err };
    }
  },
  getAllUsers: async () => {
    try {
      const response = await privateClient.get(userEndpoints.getAllUsers);
      return { response };
    } catch (err) {
      console.error("Error fetching all users:", err);
      return { err };
    }
  },
  updateProfile: async (data) => {
    try {
      const response = await privateClient.patch(
        userEndpoints.updateProfile,
        data
      );
      console.log("response api", response);
      return response.data;
    } catch (err) {
      throw new Error(err.response?.data?.message || "Profile update failed");
    }
  },
  passwordUpdate: async ({ oldPassword, newPassword, confirmNewPassword }) => {
    try {
      const response = await privateClient.patch(userEndpoints.passwordUpdate, {
        oldPassword,
        newPassword,
      });

      return { response };
    } catch (err) {
      return { err };
    }
  },
};

export default userApi;
